import { memo } from 'react';
import { Box } from '@mui/material';
import { useLocation } from 'react-router-dom';

import MenuItem from './menuItem';
import MenuTitle from './menuTitle';
import { isMenuItemSelected } from '../utils';
import { MenuSection as MenuSectionBaseProps } from '../interfaces';

const getMenuItems = ({
  menuItems,
  pathname,
  isShrinked
}: {
  menuItems: Props['menuItems'];
  pathname: string;
  isShrinked: boolean;
}) =>
  menuItems.map((menuItemProps, index) => (
    <MenuItem
      {...menuItemProps}
      key={index}
      isShrinked={isShrinked}
      isSelected={isMenuItemSelected(menuItemProps.href, pathname)}
    />
  ));

interface Props extends MenuSectionBaseProps {
  isShrinked: boolean;
}

const MenuSection = ({ title, menuItems, isShrinked }: Props) => {
  const { pathname } = useLocation();

  return (
    <Box display="flex" flexDirection="column" mt={3}>
      {title ? <MenuTitle title={title} isShrinked={isShrinked} /> : null}
      {getMenuItems({ menuItems, pathname, isShrinked })}
    </Box>
  );
};

export default memo(MenuSection);
